// extracted by mini-css-extract-plugin
export var betReload = "PromoPills-module--betReload--d4de4";
export var bonusCash = "PromoPills-module--bonusCash--3600e";
export var cardPromos = "PromoPills-module--cardPromos--bf7f0";
export var conditional = "PromoPills-module--conditional--64882";
export var expansion = "PromoPills-module--expansion--043eb";
export var icon = "PromoPills-module--icon--93213";
export var pillRow = "PromoPills-module--pillRow--7d5cf";
export var tokenPill = "PromoPills-module--tokenPill--6bdc5";
export var winningsBoost = "PromoPills-module--winningsBoost--48e15";